import React from 'react'
import PropTypes from 'prop-types'
import { motion } from 'framer-motion'

const pathVariants = {
  hidden: {
    opacity: 0,
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    transition: {
      duration: 1,
      ease: 'easeInOut',
    },
  },
}

const AnimatedCheckIcon = ({ strokeWidth, ...rest }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <motion.path
      variants={pathVariants}
      initial="hidden"
      animate="visible"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M5 13l4 4L19 7"
    />
  </svg>
)

AnimatedCheckIcon.propTypes = {
  strokeWidth: PropTypes.string,
}

AnimatedCheckIcon.defaultProps = {
  strokeWidth: '2',
}

export default AnimatedCheckIcon
